const exchangeRateSignificantDigits = 8

const exchangeRateFormatterMap = new Map<string, Intl.NumberFormat>()

/**
 * Formats a checkout exchange rate (crypto units per account-currency unit)
 * for display.
 *
 * Rates span several orders of magnitude (~1 for stablecoins, ~1e-5 for BTC),
 * so they are cut to significant digits rather than fixed decimals: every
 * asset keeps the same relative precision, small rates never fall into
 * exponent notation, and trailing zeros are dropped. Display only - the
 * checkout amount is calculated on the backend from the full rate.
 *
 * @param locale UI language used for the decimal and group separators.
 * @param value Exchange rate to format.
 * @returns The formatted rate.
 *
 * @example
 * formatExchangeRate('en', 1.0832154321098765) // '1.0832154'
 * formatExchangeRate('en', 0.000017637116331479806) // '0.000017637116'
 * formatExchangeRate('de', 1.000100010001) // '1,0001'
 */
export function formatExchangeRate(locale = 'en', value: number): string {
  let formatter = exchangeRateFormatterMap.get(locale)

  if (formatter == null) {
    formatter = new Intl.NumberFormat(locale, {maximumSignificantDigits: exchangeRateSignificantDigits})
    exchangeRateFormatterMap.set(locale, formatter)
  }

  return formatter.format(value)
}
